<template>
  <vx-card id="loader">
    <h3>Отладка расчета ML для внешних Native объявлений</h3>

    <form>
      <div class="vx-row mt-1">
        <div class="vx-col w-1/4">
          <div class="mt-1">
            <vs-input
                v-model="form.id"
                autocomplete="off"
                label="ID объявления"
                placeholder="ID объявления"
                class="mt-1 w-full"
            />
          </div>
        </div>
        <div class="vx-col w-1/4 mb-1">
          <div class="mt-1">
            <label class="vs-input--label"> DSP </label>
            <v-select :options="dictionary.dspTypes" label="name" placeholder="Выберите DSP" class="w-full" v-model="form.dspTypeId" :reduce="a => a.id">
            </v-select>
          </div>
        </div>
      </div>
      <div class="vx-row mt-1">
        <div class="vx-col w-full">
          <div>
            <vs-button class="b-btn" :disabled="tab === `ads`" @click="tab = `ads`">Объявления</vs-button>
            <vs-button class="b-btn" :disabled="tab === `avg_ctrs`" @click="tab = `avg_ctrs`">Средние CTR</vs-button>

            <span class="ml-6">Полный расчет: {{ calculated_at }}</span>
          </div>
        </div>

      </div>
    </form>

    <div v-if="tab === `ads`">
      <div class="mt-5" id="table-loader">
        <vs-table ref="dataTable" stripe
                  :data="items"
                  description
                  class="mt-5 mb-3">
          <template slot="thead">
            <vs-th class="vs-lg-1"> ID </vs-th>
            <vs-th class="vs-lg-1"> DSP </vs-th>
            <vs-th class="vs-lg-2"> Tree </vs-th>
            <vs-th class="vs-lg-2"> Buyouts (with coeffs) </vs-th>
            <vs-th class="vs-lg-2"> Clicks (with coeffs) </vs-th>
            <vs-th class="vs-lg-2"> Last Calculated </vs-th>
            <vs-th class="vs-lg-1"> Logs </vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :data="item" :key="indexItem" v-for="(item, indexItem) in data">
              <vs-td>{{ item.id }}</vs-td>
              <vs-td>{{ item.dsp_name }}</vs-td>
              <vs-td width="300">
                <div  style="overflow-y: scroll; max-height: 250px;">
                  <v-tree :data="item.sspGroups"></v-tree>
                </div>
              </vs-td>
              <vs-td>{{ item.buyouts }}</vs-td>
              <vs-td>{{ item.clicks }}</vs-td>
              <vs-td>{{ item.calculated_at | moment('DD.MM.YYYY HH:mm') }}</vs-td>
              <vs-td><vs-button @click="getLog(item.id, item.log_id, item.dsp_id)">Лог</vs-button></vs-td>
            </vs-tr>
          </template>
        </vs-table>

        <vs-pagination :total="totalPages" v-model.lazy="page" @change="loadData()"></vs-pagination>

        <vs-popup title="Лог объявления" v-if="teaserLog" :active.sync="popupView">
          <vs-collapse>
            <vs-collapse-item v-for="(val, key) in teaserLog" 
              :key="`log_item_`+key" 
              :disabled="!val.data" 
              class="teaser-log-item">
              
              <div slot="header">
                {{key+1}}. {{ val.text }}
              </div>
              <pre>{{val.data}}</pre>
            </vs-collapse-item>
          </vs-collapse>
        </vs-popup>
      </div>
    </div>

    <div v-if="tab === `avg_ctrs`">
      <div class="mt-5" id="table-loader">
        <vs-table ref="dataTable" stripe :data="avgCtrs" max-items="100" description class="mt-5 mb-3">
          <template slot="thead">
            <vs-th> DSP </vs-th>
            <vs-th> SSP Group </vs-th>
            <vs-th> Тип контента </vs-th>
            <vs-th> Показы </vs-th>
            <vs-th> Клики </vs-th>
            <vs-th> CTR </vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :data="item" :key="indexItem" v-for="(item, indexItem) in data">
              <vs-td>{{ item.dspTypeName }}</vs-td>
              <vs-td>{{ item.sspGroupName }}</vs-td>
              <vs-td>{{ item.contentTypeName }}</vs-td>
              <vs-td>{{ item.buyouts }}</vs-td>
              <vs-td>{{ item.clicks }}</vs-td>
              <vs-td>{{ item.ctr | formatNumber(3) }}</vs-td>
            </vs-tr>
          </template>
        </vs-table>

        <vs-pagination :total="totalPagesAvgCtrs" v-model.lazy="page" @change="loadAvgCtrs()"></vs-pagination>
      </div>
    </div>
  </vx-card>
</template>

<script>
import vSelect from 'vue-select';


import {VTree} from 'vue-tree-halower'
import JsonViewer from 'vue-json-viewer'
import 'vue-tree-halower/dist/halower-tree.min.css'
import qs from "qs";

export default {
  name: 'debugging-ml-external-native',
  components: {
    'v-select': vSelect,
    'v-tree': VTree,
    JsonViewer
  },
  data() {
    return {
      jsonData: { a:1, b:2, c: [1,2,3] },
      // словарь для перевода в дереве.
      dmpAttributes: [],

      // для логов.
      popupView: false,
      teaserLog: [],

      items: [],
      avgCtrs: [],

      calculated_at: null,

      dictionary:{
        dspTypes: [],
        teaserAge: [
          {label: 'Новые', value: 1}, {label: 'Старые', value: 0},
        ]
      },

      tab: 'ads',
      page: 1,
      maxItemsForPage: 15,
      totalPages: 0,
      pageAvgCtrs: 1,
      sizeAvgCtrs: 100,
      totalPagesAvgCtrs: 0,

      form: {
        id: '',
        dspTypeId: 2,
        buyouts: 0,
        is_new: null,
        enter: 'in_set'
      },

      defaultForm: {
        id: '',
        dspTypeId: 2,
        buyouts: 0,
        is_new: null,
        enter: 'in_set',
      },

      // для сбрасывания таймаута
      timeout: null,
    };
  },

  async mounted() {
    this.loadDicts();
    this.loadAvgCtrs();
  },
  watch: {
    form: {
      deep: true,
      handler(val) {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.page = 1;
          this.loadData()
        }, 500)
      }
    },
  },
  methods: {
    // загрузка данных
    loadData() {
      this.$vs.loading({
        container: '#loader',
        type: 'sound'
      });

      let request = {
        id: this.form.id,
        dspId: this.form.dspTypeId,
        // 'type': this.form.enter,
        buyouts: this.form.buyouts,
        is_new: !!this.form.is_new ? this.form.is_new.value : null,
        page: this.page,
        size: this.maxItemsForPage,
      }
      this.calculated_at = null;
      this.items = [];

      this.axios.get(`machine-learning-external-native`, {
        params: request,
        paramsSerializer: (params) => {
          return qs.stringify(params);
        }
      })
      .then((resp) => {
        if (resp.status === 204) {
          return
        }

        this.calculated_at = (new Date(resp.data.calculated_at)).toLocaleString();
        this.totalPages = resp.data.total_pages
        let items = resp.data.items;
        this.makeTree(items);
        this.items = items;
      })
      .catch((err) => {
        this.$vs.notify({
          title: 'Внимание!',
          text: 'Ошибка загрузки объявлений.' + err.toString(),
          color: 'danger'
        });
      })
      .finally(() => {
        this.$vs.loading.close('#loader > .con-vs-loading');
      });
    },

    loadDicts() {
      this.axios.get('machine-learning-external-native/dicts')
          .then(resp => {
            this.$vs.loading.close('#loading-full-page > .con-vs-loading');

            this.dictionary.dspTypes = resp.data.dspTypes;
          })
    },

    loadAvgCtrs() {
      const params = {
        page: this.pageAvgCtrs,
        size: this.sizeAvgCtrs
      };
      this.axios.get('machine-learning-external-native/avg-ctrs', params)
          .then(resp => {
            this.$vs.loading.close('#loading-full-page > .con-vs-loading');

            this.avgCtrs = resp.data.items;
            this.totalPagesAvgCtrs = resp.data.totalPages;
          })
    },

    setDefaultForm() {
      Object.assign(this.form, JSON.parse(JSON.stringify(this.defaultForm)))
    },

    makeTree(data) {
      data.map((val) => {
        let tree = [{
          title: "sspGroups",
          expanded: false,
          children: [],
        }]
        val.sspGroups.map((sspGroup) => {
          let children = [];
          for (let key in sspGroup) {
            if (key === 'sspGroup') {
              children.push({
                title: 'name' + ': ' + this.dmpAttributes[sspGroup[key]],
              });
              continue;
            }

            let title = key + ': ' + sspGroup[key];

            children.push({
              title: title
            });
          }

          tree[0].children.push({
            title: 'sspGroup: ' + sspGroup.sspGroup,
            expanded: false,
            children: children
          })
        });
        val.sspGroups = tree;
      })
    },

    getLog(teaserID, logID, dspID) {
      this.$vs.loading({
        container: '#loader',
        type: 'sound'
      });
      this.teaserLog = [];
      this.axios.get(`machine-learning-external-native/log/${teaserID}?dspId=${dspID ? dspID : ""}&logId=${logID ? logID : ""}`)
          .then((resp) => {
            for (let key in resp.data) {
              this.teaserLog.push(resp.data[key])
            }
            this.popupView = true;
          })
          .catch(err => {
            this.$vs.notify({
              title: 'Внимание!',
              text: 'Ошибка загрузки лога.' + err.toString(),
              color: 'danger'
            });
          })
          .finally(() => {
            this.$vs.loading.close('#loader > .con-vs-loading');
          });
    },
  },

};
</script>

<style lang="scss">
.b-btn {
  border-radius: 0;
  width: 200px;
}

ol.numerable li {
  list-style: inside decimal !important;
}

.con-vs-popup .vs-popup {
  width: 1000px !important;
  height: auto !important;
}

.vs-collapse-item--header {
  font-size: 1em;
  font-weight: bold;
}

.teaser-log-item.vs-collapse-item.disabledx {
  opacity: 1;
}

.teaser-log-item.vs-collapse-item.disabledx .vs-collapse-item--icon-header {
  visibility: hidden;
}

.vs-pagination--mb {
    justify-content: center !important;
}
</style>
